// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/news-list/news-list.scss
 ** module id = 110
 ** module chunks = 0 1
 **/